import { render } from "./AllPayments.vue?vue&type=template&id=28141a31"
import script from "./AllPayments.vue?vue&type=script&lang=js"
export * from "./AllPayments.vue?vue&type=script&lang=js"

import "./AllPayments.vue?vue&type=style&index=0&id=28141a31&lang=css"

import exportComponent from "C:\\Users\\Admin\\NodeProjects\\FibreFrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__